import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { RoleNomenclature, RoleNomenclatureString } from '../../shared/nomenclatures/role-nomenclature';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  	
	constructor(private router: Router, private authService: AuthService) {}

  	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const currentUser = this.authService.currentUserValue;
	
		if (currentUser && currentUser.role === RoleNomenclatureString.ADMIN) {
	  		return true;
		}

		this.router.navigate(['/admin/appointments']);
		return false;  	}
}